<template>
	<ui-dialog
		ref="dialog"
		:title="title"
		class="media-share-dialog"
		closable
	>
		<h6 class="ui-subheading">Link lifetime</h6>
		<ui-radio-group
			v-model="lifetime"
			class="lifetime-radio-button-group ui-layout ui-alignment-center-space-between"
		>
			<ui-radio
				:label="customLabel | date('yyyy-MM-dd')"
				value="0"
				@change="showDatepicker"
			/>
			<ui-radio
				label="24 hours"
				value="86400"
			/>
			<ui-radio
				label="One week"
				value="604800"
			/>
			<ui-radio
				label="4 weeks"
				value="2419200"
			/>
			<ui-radio
				label="Forever"
				value="-1"
			/>
		</ui-radio-group>
		<ui-datepicker
			ref="datepicker"
			v-model="selectedDate"
			:disabled-dates="isDateBeforeNow"
			class="ui-datepicker__right ui-datepicker__hidden"
			close-on-select
			label="Link expires date"
		/>
		<div class="ui-layout ui-gutter ui-alignment-center-space-between">
			<div class="ui-layout-item ui-input--link-password">
				<ui-input
					v-model="password"
					autocomplete="new-password"
					label="Link password (optional)"
					type="password"
				/>
			</div>
			<div class="ui-layout-item ui-size-50 ui-checkbox--downloadable">
				<ui-checkbox
					v-model="isDownloadable"
					label="Enable easy download via button"
					tooltip="Check to show download button on player"
				/>
			</div>
		</div>
		<h6 class="ui-subheading">Share by</h6>
		<ui-tabs>
			<ui-tab class="ui-tab__reset-padding" label="Link">
				<share-link
					:downloadable="isDownloadable"
					:expires="expires"
					:lifetime=" parseInt(lifetime)"
					:media-id="mediaId"
					:password="password"
				/>
			</ui-tab>
			<ui-tab class="ui-tab__reset-padding" label="E-mail">
				<share-email
					:downloadable="isDownloadable"
					:expires="expires"
					:lifetime="parseInt(lifetime)"
					:media-id="mediaId"
					:password="password"
					@send="$refs.dialog.close()"
				/>
			</ui-tab>
		</ui-tabs>
	</ui-dialog>
</template>

<script>
import addSeconds from "date-fns/addSeconds";
import endOfDay from "date-fns/endOfDay";

import UiCheckbox from "lib/components/ui/Checkbox";
import UiDatepicker from "lib/components/ui/Datepicker";
import UiDialog from "lib/components/ui/Dialog";
import UiInput from "lib/components/ui/Input";
import UiRadio from "lib/components/ui/Radio";
import UiRadioGroup from "lib/components/ui/RadioGroup";
import UiTab from "lib/components/ui/Tab";
import UiTabs from "lib/components/ui/Tabs";
import ShareEmail from "components/media/ShareEmail";
import ShareLink from "components/media/ShareLink";

const DEFAULT_LIFETIME = "604800"; // possible values: 86400 (24h), 604800 (1w), 2419200 (1m), -1 (forever)
const FOREVER = 4294967294; // 32bit unsigned int

export default {
	name: "MediaShareDialog",
	components: {
		UiCheckbox,
		UiDatepicker,
		UiDialog,
		UiInput,
		UiRadio,
		UiRadioGroup,
		UiTab,
		UiTabs,
		ShareEmail,
		ShareLink
	},
	data() {
		return {
			customLabel: "Custom",
			expires: 0,
			isDownloadable: false,
			lifetime: DEFAULT_LIFETIME,
			mediaId: "",
			password: "",
			selectedDate: null, // date object
			title: ""
		};
	},
	watch: {
		lifetime(val) {
			if (val !== "0")
				this.customLabel = "Custom";

			if (val === "-1")
				this.expires = FOREVER;
			else
				this.expires = 0;
		},
		selectedDate(val) {
			// showDatePicker sets date, this is asynchronous so date on customLabel needs to be set here
			if (this.lifetime === "0") {
				this.customLabel = this.selectedDate;
				this.expires = Math.floor(endOfDay(val).getTime() / 1000);
			}
		}
	},
	mounted() {
		this.open = (mediaItem) => {
			this.mediaId = mediaItem.media_id;
			this.password = "";
			this.lifetime = DEFAULT_LIFETIME;
			this.selectedDate = addSeconds(new Date(), parseInt(DEFAULT_LIFETIME));
			this.title = `Share media - ${mediaItem.title}`;
			this.isDownloadable = false;
			this.$refs.dialog.open();
		};
	},
	methods: {
		isDateBeforeNow(date) {
			const now = new Date();

			return now.getTime() > date.getTime();
		},
		showDatepicker() {
			this.selectedDate = addSeconds(new Date(), parseInt(DEFAULT_LIFETIME));
			this.$refs.datepicker.focus();
		}
	}
};
</script>

<style lang="scss" scoped>
.lifetime-radio-button-group {
	div:first-child {
		width: 108px;
	}
}
.ui-subheading {
	margin-bottom: 0;
}
.ui-tab__reset-padding {
	padding-left: 0;
	padding-right: 0;
	padding-bottom: 0;
}
.ui-layout-item {
	&.ui-input--link-password {
		min-width: 368px;
	}
	&.ui-checkbox--downloadable {
		min-width: 226px;
	}
	white-space: nowrap;
}
</style>
